
import React, { useState } from "react";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import SoftBox from "components/SoftBox";
import Card from "@mui/material/Card"; 
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DataTable from "./DataTable";

const ContactUsActions = () => {
  const [rows, setRows] = useState([]);
  const [totalEntries, setTotalEntries] = useState(0);
  const [page, setPage] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(8);
  const [loading, setLoading] = useState(false);
  
  const handleEntriesChange = (newEntries) => {
    setEntriesPerPage(newEntries);
    setPage(1); 
  };

  const columns = [

    { Header: "IP Address", accessor: "ip", align: "left" },
    { Header: "Location" , accessor:"country" , align:"left"},
    { Header: "Date & Time", accessor: "created_at", align: "left" },
    // { Header: "Likes/Dislikes", accessor: "likes_dislikes", align: "left" },
];

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div style={{ width: "100%", marginTop: "0px" }}>
        
        <Card>
          <SoftBox p={3} lineHeight={1.2}>
            {loading ? (
              <p style={{ textAlign: "center" }}>Loading data...</p>
            ) : (
              <>
                <div style={{ width: "100%" }}>
                  <DataTable
                    table={{ columns, rows }}
                    entriesPerPage={{
                      defaultValue: entriesPerPage,
                      entries: [5, 10, 15],
                    }}
                    canSearch
                    date
                    csv
                    showTotalEntries
                    onEntriesChange={handleEntriesChange}
                    totalPages={Math.ceil(totalEntries / entriesPerPage)}
                  />
                </div>
              </>
            )}
          </SoftBox>
        </Card>
      </div>
    </DashboardLayout>
  );
};
export default ContactUsActions;
